var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLargeNote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 9.37125 10.5075 L 16.191562 3.687187 C 16.655625 3.223125 16.655625 2.466562 16.191562 2.0025 L 15.539062 1.35 C 15.075 0.883125 14.318437 0.883125 13.854375 1.35 L 7.03125 8.170312 L 6.339375 11.039062 C 6.305625 11.176875 6.429375 11.295 6.564375 11.26125 Z M 9.37125 10.5075 ",
    transform: "matrix(1.388889,0,0,1.388889,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 13.17375 2.027813 L 15.510937 4.367812 ",
    transform: "matrix(1.388889,0,0,1.388889,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 7.03125 8.170312 L 9.37125 10.5075 ",
    transform: "matrix(1.388889,0,0,1.388889,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 14.740312 11.705625 L 14.740312 15.508125 C 14.740312 16.332187 14.070937 17.001562 13.246875 17.001562 L 2.491875 17.001562 C 1.667812 17.001562 1.00125 16.332187 1.00125 15.508125 L 1.00125 5.518125 C 1.00125 4.69125 1.667812 4.024687 2.491875 4.024687 L 6.302812 4.024687 ",
    transform: "matrix(1.388889,0,0,1.388889,0,0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeNote);
export default __webpack_public_path__ + "static/media/large_note.a3904a8df2edbd987891a4caa43f669f.svg";
export { ForwardRef as ReactComponent };